import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Address from '@/views/Address.vue'
import Block from '@/views/Block.vue'
import Blocks from '@/views/Blocks.vue'
import BlocksSearch from '@/views/BlocksSearch.vue'
import Holders from '@/views/Holders.vue'
import Transaction from '@/views/Transaction.vue'
import NotFound from '@/views/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/address/:id',
    name: 'Address',
    component: Address,
  },
  {
    path: '/block/:id',
    name: 'Block',
    component: Block,
  },
  {
    path: '/blocks/:id?',
    name: 'Blocks',
    component: Blocks,
  },
  {
    path: '/blocks/search/:time',
    name: 'BlocksSearch',
    component: BlocksSearch,
  },
  {
    path: '/holders',
    name: 'Holders',
    component: Holders,
  },
  {
    path: '/tx/:id',
    name: 'Transaction',
    component: Transaction,
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound,
  },
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { left: 0, top: 0 }
  //   }
  // }
})

export default router
